(function (window) {
    "use strict";

    window.getsVisible = function (elem) {
        var rect = elem.getBoundingClientRect();

        var height = (window.innerHeight || document.documentElement.clientHeight);
        var width = (window.innerWidth || document.documentElement.clientWidth);
        return (
            (
                xAxisIsInviewport(rect, width) &&
                yAxisIsInviewport(rect, height)
            ) || (
                isViewInRect(rect, width, height)
            )
        );
    }
    function isViewInRect(rect, width, height) {
        return (
            (
                rect.top <= 0 &&
                rect.bottom >= height
            ) || (
                rect.left <= 0 &&
                rect.right >= width
            )
        );
    }
    function yAxisIsInviewport(rect, height) {
        return (
            (
                rect.top >= 0 &&
                rect.top <= height
            ) || (
                rect.bottom >= 0 &&
                rect.bottom <= height
            )
        );
    }
    function xAxisIsInviewport(rect, width) {
        return (
            (
                rect.left >= 0 &&
                rect.left <= width
            ) || (
                rect.right >= 0 &&
                rect.right <= width
            )
        );
    }

})(window);


// $.fn.isElementInViewport
(function ($) {
    $.fn.isElementInViewport = function () {
        return window.getsVisible(this[0]);
    }
})(jQuery);